import { rootUiActions, rootUiTypes } from 'app-components/flux/root-ui';
import store from 'app-components/utils/redux-store';
import { Map as ImmutableMap } from 'immutable';

import type { RequestDialogProps } from './types';

export const REQUEST_DIALOG = 'REQUEST_DIALOG';

export const dispatchRequestDialog = (props?: RequestDialogProps) => {
  store?.dispatch(
    rootUiActions.createDialog(
      rootUiTypes.mkRootUiData({
        type: REQUEST_DIALOG,
        props: ImmutableMap(props || {}),
      }),
    ),
  );
};

export default dispatchRequestDialog;
